<template>
  <div class="category-dishes-swiper">
    <swiper :options="swiperOptions" ref="mySwiper" class="dishes-slider">
      <swiper-slide v-for="(dish, index) in giftPromotionData.dishes" :key="dish.ID">
        <div class="option" :class="{ 'inactive': dish.needSum }">
          <dish
            :dish="dish"
            :giftMode="true"
            :giftSelected="promotionsGifts[giftPromotionData.id] && promotionsGifts[giftPromotionData.id].ID === dish.ID"
            @selectGift="$emit('selectGift', dish)"
          />
          <div class="min-sum-mark" v-if="dish.needSum">Нужно заказать на {{ dish.needSum }} <rub /></div>
        </div>
      </swiper-slide>
      <div class="dishes-slider-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
  import Dish from '/src/components/Dish'

  export default {
    name: 'GiftDishesSwiper',
    data () {
      return {
        swiperOptions: {
          slidesPerView: 'auto',
          spaceBetween: 0,
          pagination: {
            el: '.dishes-slider-pagination',
            clickable: false
          },
          loop: false,
          simulateTouch: true,
          speed: 500
        }
      }
    },
    components: {
      Dish
    },
    props: {
      promotionsGifts: {
        type: Object,
        required: true
      },
      giftPromotionData: {
        type: Object,
        required: true
      }
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/GiftDishesSwiper.vue